module.exports = "/images/vendor/primevue/resources/hue.png?0614c27197fc3ce572e161840d23b2af";